import { makeStyles } from '@mui/styles';
import Grid from 'apollo-react/components/Grid';
import React from 'react';
import ReactResizeDetector from 'react-resize-detector';

import EntityDetailsHeader from './EntityDetailsHeader';
import Menus from './Menus';
import { useFormSelector } from '../../custom-hooks';
import { useWindowDimensions } from '../../custom-hooks/useWindowDimensions';
import { getShowMenus } from '../../form-designer/selectors/runtime.selectors';

const useStyles = makeStyles(({ breakpoints }) => ({
  container: {
    padding: '10px 15px 10px 25px',
    alignItems: 'center',
    flexDirection: 'column',
    [breakpoints?.up('lg')]: {
      flexDirection: 'row',
    },
  },
  mobileContainer: {
    padding: '5px 16px 0',
    alignItems: 'center',
    flexDirection: 'column',
    borderBottom: '1px solid #e9e9e9',
    backgroundColor: '#f8f9fb',
  },
  menu: {
    alignSelf: 'flex-start',
    paddingTop: 12,
    [breakpoints?.up('lg')]: {
      alignSelf: 'center',
      paddingTop: 0,
    },
  },
}));

const HeaderSection = ({ onHeightChange }) => {
  const classes = useStyles();

  const showMenus = useFormSelector(getShowMenus);
  const { isMobileDevice } = useWindowDimensions();

  const onResize = (w, h) => {
    onHeightChange(h);
  };

  return (
    <>
      <Grid className={isMobileDevice ? classes.mobileContainer : classes.container} container>
        <Grid item xs={12} container style={{ flex: 1 }}>
          <div id="header-section">
            <EntityDetailsHeader />
          </div>
        </Grid>
        <Grid item className={classes.menu}>
          {showMenus && !isMobileDevice && <Menus />}
        </Grid>
      </Grid>
      {!isMobileDevice && <ReactResizeDetector handleHeight onResize={onResize} />}
    </>
  );
};

export default HeaderSection;
